import React, { useRef } from 'react';
import { useOutsideClick } from '@tencent/tea-component';
import { useTranslation } from 'react-i18next';
import { MediaDeviceListProps, MediaDeviceListItem } from './MediaDeviceList.type';
import './MediaDeviceList.scss';

const MediaDeviceList: React.FC<MediaDeviceListProps> = ({ dataset, onHide, onChange }) => {
  const ref = useRef(null);
  const { t } = useTranslation();
  const { listen } = useOutsideClick(ref);
  listen((e) => {
    onHide(e);
  });
  const onDeviceClick = (device: MediaDeviceInfo | boolean, type?: MediaDeviceListItem['className']) => {
    onChange(device, type);
    onHide();
  };

  const renderList = ({
    data,
    isShowDefault,
    type,
    selectedId,
  }: {
    data: MediaDeviceListItem['data'];
    isShowDefault: boolean;
    type: 'speaker' | 'micphone' | 'camera';
    selectedId?: string;
  }) =>
    data?.length > 0 ? (
      <>
        {isShowDefault && (
          <div
            className={`media-device-list__item ${selectedId === '' ? 'media-device-list__item_selected' : ''}`}
            onClick={() => onDeviceClick(false, type)}
          >
            {t('系统默认')}
          </div>
        )}
        {data.map((device) => (
          <div
            className={`media-device-list__item ${
              selectedId === device.deviceId ? 'media-device-list__item_selected' : ''
            }`}
            key={device.deviceId}
            onClick={() => onDeviceClick(device, type)}
          >
            {device.label}
          </div>
        ))}
      </>
    ) : (
      <div className="media-device-list__item" onClick={() => onHide()}>
        {t('无可用设备')}
      </div>
    );

  return (
    <div className="media-device-list" ref={ref}>
      {dataset.map((item, index) => (
        <div key={index} className="media-device-list__grid">
          <div className={`media-device-list__title media-device-list__title_${item.className}`}>{item.title}</div>
          {item.alwaysDefault ? (
            <div
              className="media-device-list__item media-device-list__item_selected"
              onClick={() => onDeviceClick(false, item.className)}
            >
              {t('系统默认')}
            </div>
          ) : (
            renderList({
              data: item.data,
              isShowDefault: item.showDefault,
              type: item.className,
              selectedId: item?.selectedId ?? '',
            })
          )}
        </div>
      ))}
    </div>
  );
};

export default MediaDeviceList;
